/** Optional receipt line items (name + price). */
import type { ReceiptLine } from "../api-types";
import { h } from "../dom-helpers";
import { strings } from "../strings";

export interface ReceiptLinesEditor {
  el: HTMLElement;
  /** Entered lines; `null` when a row is half-filled or has an invalid price. */
  read(): ReceiptLine[] | null;
}

export function createReceiptLinesEditor(): ReceiptLinesEditor {
  const list = h("div", { className: "stack" });

  const addRow = () => {
    const name = h("input", { name: "lineName", placeholder: strings.billLineName, autocomplete: "off" });
    const price = h("input", { name: "linePrice", type: "number", min: "0", step: "1", inputMode: "numeric", placeholder: strings.billLinePrice });
    const row = h("div", { className: "row line" }, name, price);
    row.append(h("button", { type: "button", className: "ghost", onclick: () => row.remove() }, strings.billRemoveLine));
    list.append(row);
    name.focus();
  };

  const el = h(
    "fieldset",
    { className: "stack" },
    h("legend", {}, strings.billLines),
    list,
    h("button", { type: "button", className: "secondary", onclick: addRow }, strings.billAddLine),
  );

  return {
    el,
    read() {
      const lines: ReceiptLine[] = [];
      for (const row of Array.from(list.children)) {
        const [nameInput, priceInput] = Array.from(row.querySelectorAll("input"));
        const name = nameInput?.value.trim() ?? "";
        const priceText = priceInput?.value.trim() ?? "";
        if (!name && !priceText) continue;
        const priceCzk = Number(priceText);
        if (!name || !priceText || !Number.isInteger(priceCzk) || priceCzk < 0) return null;
        lines.push({ name, priceCzk });
      }
      return lines;
    },
  };
}
